<template>
  <div class="box6new">
    <pageTitle title="该多则多，夯实核心技术" text="三大课程优势助力快速进阶" />
    <div class="one">优势一</div>
    <div class="subTitle1">
      分层次高效教学：先“通”后“精”<br />倍速突破壁垒应对企业内常见工作&复杂工作
    </div>
    <div class="vsbox">
      <div class="other">
        <p>其他机构体系</p>
        <p>
          把源码、应用、扩展知识一起讲，学生学习压力巨<br />大，学过不会用，吸收效果差。
        </p>
      </div>
      <div class="mine">
        <div class="item">
          <div class="specialPro">
            <img
              src="../../assets/architect/box6new/icon1.png"
              alt=""
            />
            <p>项目篇</p>
            <p>应对企业真实场景</p>
          </div>
          <p class="txt">
            学完即用，更切合企业项目实际情况，可直接上手做<br />业务。
          </p>
        </div>
        <div class="item">
          <div class="specialPro">
            <img
              src="../../assets/architect/box6new/icon2.png"
              alt=""
            />
            <p>实用篇</p>
            <p>应对企业常见工作</p>
          </div>
          <p class="txt">
            课程内容由浅入深，循序渐进，抽取常用必备知识，<br />让学生学得会且用得上。
          </p>
        </div>
        <div class="item">
          <div class="specialPro">
            <img
              src="../../assets/architect/box6new/icon3.png"
              alt=""
            />
            <p>高级篇</p>
            <p>应对企业复杂工作</p>
          </div>
          <p class="txt">
            加深学生对源码、原理、高级用法的使用能力，应对<br />高难度工作。
          </p>
        </div>
      </div>
    </div>
    <div class="two">优势二</div>
    <div class="subTitle2">
      分阶段学习，从基础到深入，覆盖职业所需的<br />完整技能，分分钟把控整体技术关口
    </div>
    <div class="exp">6个月课程稳步提升，快速进阶Java架构师</div>
    <div class="progressBox">
      <div class="left"></div>
      <div class="right">
        <div class="item" v-for="(item, index) in list" :key="index">
          <p>
            {{ item.title }}<span>{{ item.time }}</span>
          </p>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../../components/common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          title: "设计与工具一览",
          time: "（57h）",
          desc: "掌握架构师常用工具和设计思维，将技术落地到实际项目中去",
        },
        {
          title: "大师的经典源码",
          time: "（36h）",
          desc: "掌握Spring体系、Tomcat、Mybatis、Jdk等经典源码，领悟大师的智慧",
        },
        {
          title: "架构师性能调优",
          time: "（27h）",
          desc: "掌握网站中各个提升性能的核心关键点，从代码到数据逐层剖析",
        },
        {
          title: "云服务与底层部署",
          time: "（33h）",
          desc: "掌握Docker，K8s，LVS及Keepalived等底层服务的部署架构",
        },
        {
          title: "数据层深度优化",
          time: "（39h）",
          desc: "掌握Mysql、MongoDB、ES、文件存储、Redis等各种存储形式的深度优化",
        },
        {
          title: "中间件高级应用",
          time: "（30h）",
          desc: "掌握Nginx、消息队列等常用中间件的高级特性，从会使用到用到极致",
        },
        {
          title: "框架架构与原理",
          time: "（39h）",
          desc: "掌握分布式与微服务的深层原理，具备框架二次开发定制能力",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box6new {
  padding-top: 80px;
  background-color: #eef5ff;
  .one,
  .two {
    background: url("../../assets/architect/box6new/title1.png");
    width: 356px;
    height: 48px;
    background-size: cover;
    margin: 50px auto 30px;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 48px;
    letter-spacing: 0px;
    color: #ffffff;
    text-align: center;
  }
  .two {
    background: url("../../assets/architect/box6new/title2.png");
    background-size: cover;
    margin: 80px auto 30px;
  }
  .subTitle1,
  .subTitle2 {
    font-family: PingFangSC-Semibold;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 48px;
    letter-spacing: 0px;
    color: #24375c;
    text-align: center;
    margin-bottom: 40px;
  }
  .vsbox {
    background: url("../../assets/architect/box6new/bgc.png");
    width: 735px;
    background-size: cover;
    margin: 0 auto;
    overflow: hidden;
    .other {
      text-align: center;
      p:nth-child(1) {
        font-family: PingFangSC-Medium;
        font-size: 32px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #475466;
        margin-top: 40px;
      }
      p:nth-child(2) {
        font-family: PingFangSC-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 0px;
        color: #6b7e99;
        margin-top: 14px;
      }
    }
    .mine {
      margin-top: 123px;
      .item {
        padding: 30px 0 0 23px;
        box-sizing: border-box;
        width: 630px;
        height: 168px;
        background-color: #ffffff;
        box-shadow: 0px 6px 24px 0px #3080f0;
        border-radius: 14px;
        margin-bottom: 30px;
        margin: 0 auto 30px;
        .txt {
          font-family: PingFangSC-Regular;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 36px;
          letter-spacing: 0px;
          margin-top: 4px;
          color: #6b7e99;
        }
        .specialPro {
          display: flex;

          img {
            width: 34px;
            height: auto;
            object-fit: contain;
          }
          p:nth-child(2) {
            font-family: PingFangSC-Medium;
            font-size: 32px;
            font-weight: normal;
            font-stretch: normal;
            margin: 0 19px 0 12px;
            letter-spacing: 0px;
            color: #1f324d;
          }
          p:nth-child(3) {
            font-family: PingFangSC-Medium;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #1f324d;
            position: relative;
            top: 10px;
          }
        }
      }
    }
  }
  .exp {
    background: url("../../assets/architect/box6new/exp.png");
    width: auto;
    height: 133px;
    margin: -20px auto 35px;
    background-size: cover;
    font-family: PingFangSC-Semibold;
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 133px;
    text-align: center;
    letter-spacing: 0px;
    color: #3388ff;
  }
  .progressBox {
  width: 693px;
  margin: 0 auto;
  justify-content: space-between;
  display: flex;
    .left {
     background: url("../../assets/architect/box6new/left.png");
    background-size: cover;
    width: 16px;
    height: 1300px;
    }
    .right {
      .item {
        width: 660px;
        height: 160px;
        background-color: #ffffff;
        box-shadow: 0px 6px 24px 0px #dbeaff;
        border-radius: 20px;
        padding: 30px;
        box-sizing: border-box;
        margin-bottom: 30px;
        p:nth-child(1) {
          font-family: PingFangSC-Medium;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 26px;
          letter-spacing: 0px;
          color: #1f324d;
          span {
            font-family: PingFangSC-Medium;
            font-size: 24px;
            font-weight: normal;
            letter-spacing: 0px;
            color: #ff4d24;
          }
        }
        p:nth-child(2) {
          font-family: PingFangSC-Regular;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 36px;
          letter-spacing: 0px;
          color: #6b7e99;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
